module.exports = __webpack_public_path__ + "img/居住地真实性-文字信息1.a6a79b6b.png";